import Layout from '@/layout/index.vue';
var financialRouter = {
  path: '/financial',
  component: Layout,
  redirect: '/financial/deposit',
  name: 'Financial',
  meta: {
    title: '财务管理'
  },
  children: [{
    path: 'deposit',
    component: function component() {
      return import('@/views/financial/deposit/index.vue');
    },
    name: 'FinancialDeposit',
    meta: {
      title: '充值管理'
    },
    children: [{
      path: 'list',
      component: function component() {
        return import('@/views/financial/deposit/list/index.vue');
      },
      name: 'FinancialDepositList',
      meta: {
        title: '充值记录'
      }
    }]
  }, {
    path: 'withdraw',
    component: function component() {
      return import('@/views/financial/withdraw/index.vue');
    },
    name: 'FinancialWithdraw',
    meta: {
      title: '提现管理'
    },
    children: [{
      path: 'request',
      component: function component() {
        return import('@/views/financial/withdraw/request/index.vue');
      },
      name: 'FinancialWithdrawRequest',
      meta: {
        title: '提现申请'
      }
    }, {
      path: 'push',
      component: function component() {
        return import('@/views/financial/withdraw/push/index.vue');
      },
      name: 'FinancialWithdrawPush',
      meta: {
        title: '推送代付'
      }
    }, {
      path: 'list',
      component: function component() {
        return import('@/views/financial/withdraw/list/index.vue');
      },
      name: 'FinancialWithdrawList',
      meta: {
        title: '提现订单'
      }
    }, {
      path: 'plan',
      component: function component() {
        return import('@/views/financial/withdraw/plan/index.vue');
      },
      name: 'FinancialPayoutPlan',
      meta: {
        title: '代付计划'
      }
    }]
  }, {
    path: 'payment',
    component: function component() {
      return import('@/views/financial/payment/index.vue');
    },
    name: 'FinancialPayment',
    meta: {
      title: '支付管理'
    },
    children: [{
      path: 'list',
      name: 'FinancialPaymentList',
      component: function component() {
        return import('@/views/financial/payment/list/index.vue');
      },
      meta: {
        title: '支付通道'
      }
    }, {
      path: 'request-log',
      name: 'FinancialPaymentRequestLog',
      component: function component() {
        return import('@/views/financial/payment/request-log/index.vue');
      },
      meta: {
        title: '支付请求日志'
      }
    }, {
      path: 'callback-log',
      name: 'FinancialPaymentCallbackLog',
      component: function component() {
        return import('@/views/financial/payment/callback-log/index.vue');
      },
      meta: {
        title: '支付回调日志'
      }
    }]
  }, {
    path: 'complaint',
    component: function component() {
      return import('@/views/financial/complaint/index.vue');
    },
    name: 'FinancialComplaint',
    meta: {
      title: '投诉订单'
    }
  }]
};
export default financialRouter;